import React, { useEffect, useState } from "react";

/* plugin */
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
/* plugin end */

/* service */
import formService from "../../services/formService";
/* service end */

/* component */
import ErrorMsgComp from "../../components/ErrorMsgComp";
import InnerBgComp from "../../components/InnerBgComp";
import AuthHeadingComp from "../../components/AuthHeadingComp";
import Header from "../../components/Header";
/* component end */

const SignInNotActiveLoan = () => {
  /* form */
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  /* form end */

  /* password function */
  const [eyeIcon, setEyeIcon] = useState(false);
  const togglePassword = () => {
    setEyeIcon(!eyeIcon);
  };
  /* password function end */

  /* Email pattern validation */
  const [emailPattern, setEmailPattern] = useState("test@leo9studio.com");
  /* Email pattern validation end */

  useEffect(() => {
    /* Email pattern validation */
    let email = emailPattern;
    let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (regex.test(email)) {
      let parts = email.split("@");
      let username = parts[0];
      let modifiedUsername = `${username[0]}${username
        .slice(1, -1)
        .split("")
        .map(() => "*")
        .join("")}${username[username.length - 1]}`;
      let domain = parts[1];
      let modifiedEmail = `${modifiedUsername}@${domain}`;
      setEmailPattern(modifiedEmail);
    } else {
      setEmailPattern("");
    }
    /* Email pattern validation end */

    /* form service */
    formService.inputEmptyCheck();
    /* form service end */
  }, []);

  return (
    <div>
      {/* Header Starts */}
      <Header loginBtn={true} />
      {/* Header Ends */}

      {/* Main Container Starts */}
      <div className="main-container">
        <InnerBgComp bgImg={true} />

        {/* start */}
        <div className="comm-rev">
          <div className="container">
            {/* heading component */}
            <AuthHeadingComp />
            {/* heading component end */}

            {/* form */}
            <motion.div
              initial={{ y: 60, scale: 0.8, opacity: 0 }}
              animate={{ y: 0, scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="form-box"
            >
              <div className="auth-hdn-box">
                <h2 className="auth-hdn">Sign in</h2>
                <div className="auth-para">
                  <p>
                    You already have an account with <span>{emailPattern}</span>
                    . {"\n"}
                    Please add your password to sign in.
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit()}>
                <div className="form-grp-field">
                  <div className="form-grp int-padr">
                    <input
                      className="form-field"
                      type={eyeIcon ? "text" : "password"}
                      id="password"
                      name="password"
                      // defaultValue={"parool"}
                      {...register("password", {
                        required: "Password is required",
                      })}
                    />
                    <p className="form-label">Password</p>
                    <i
                      className={`view-pass ${
                        eyeIcon ? "icon-eye" : "icon-eye-slash"
                      }`}
                      onClick={() => togglePassword()}
                    ></i>
                  </div>
                  {errors.password && (
                    <ErrorMsgComp errorMessage={errors.password.message} />
                  )}
                </div>
                <div className="auth-para ap-txt-cen">
                  <b className="comm-link"> Forgot password? </b>
                </div>
                <button className="button button--block" type="submit">
                  <span>Sign In</span>
                </button>
              </form>
            </motion.div>
            {/* form end */}
          </div>
        </div>
        {/* end */}
      </div>
      {/* Main Container Ends */}
    </div>
  );
};

export default SignInNotActiveLoan;
